import {
  CLEAR_ALL_CUSTOMERS,
  DELETE_CUSTOMER_ACCOUNT,
  DELETE_CUSTOMER_PENDING,
  ENROLL_CUSTOMER,
  GET_CUSTOMER_POINT_HISTORY,
  LIST_ALL_CUSTOMERS,
  LIST_ALL_HISTORICAL_CUSTOMERS,
  LIST_CUSTOMERS_PENDING,
  LIST_CUSTOMERS_POINTS,
  LIST_RAFFLE_CUSTOMERS,
  PREVIEW_CUSTOMER_FILE,
  RESTORE_HISTORICAL_CUSTOMER,
  SAVE_CUSTOMER,
  SET_CUSTOMER_TICKET,
  STORE_ALL_CUSTOMERS,
  STORE_ALL_HISTORICAL_CUSTOMERS,
  STORE_ALL_RAFFLE_CUSTOMERS,
  STORE_CUSTOMER_POINT_HISTORY,
  STORE_CUSTOMER_TICKET,
  STORE_CUSTOMERS_PENDING,
  STORE_CUSTOMERS_POINTS,
  STORE_UPDATED_CUSTOMER,
  STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW,
  STORE_UPDATED_CUSTOMER_WITH_PREVIEW,
  VALIDATE_CUSTOMER_NAME,
} from '../../constants/customer';

export const listAllCustomers = (data) => ({
  type: LIST_ALL_CUSTOMERS,
  data,
});

export const listAllHistoricalCustomers = (locationId) => ({
  type: LIST_ALL_HISTORICAL_CUSTOMERS,
  locationId,
});

export const storeAllHistoricalCustomers = (data) => ({
  type: STORE_ALL_HISTORICAL_CUSTOMERS,
  data,
});

export const restoreHistoricalCustomer = (customerId, onSuccess, onError) => ({
  type: RESTORE_HISTORICAL_CUSTOMER,
  customerId,
  onSuccess,
  onError,
});

export const getPointHistory = (data) => ({
  type: GET_CUSTOMER_POINT_HISTORY,
  data,
});

export const storePointHistory = (pointHistory) => ({
  type: STORE_CUSTOMER_POINT_HISTORY,
  pointHistory,
});

export const enrollCustomer = (
  phone,
  locationId,
  points,
  photo,
  manual,
  callback
) => ({
  type: ENROLL_CUSTOMER,
  phone,
  locationId,
  points,
  photo,
  manual,
  callback,
});

export const setCustomerTicket = (
  userId,
  pendingId,
  ticket,
  callback,
  photo
) => ({
  type: SET_CUSTOMER_TICKET,
  userId,
  pendingId,
  ticket,
  photo,
  callback,
});
export const listCustomerPending = (date, locationId) => ({
  type: LIST_CUSTOMERS_PENDING,
  date,
  locationId,
});

export const deleteCustomerPending = (intent, pendingId, date, locationId) => ({
  type: DELETE_CUSTOMER_PENDING,
  intent,
  pendingId,
  date,
  locationId,
});

export const listCustomerPoints = (userId, date, locationId) => ({
  type: LIST_CUSTOMERS_POINTS,
  userId,
  date,
  locationId,
});

export const storeAllCustomers = (data) => ({
  type: STORE_ALL_CUSTOMERS,
  data,
});

export const storeAllCustomerPending = (data) => ({
  type: STORE_CUSTOMERS_PENDING,
  data,
});

export const storeCustomerTicket = (customerPendingItem) => ({
  type: STORE_CUSTOMER_TICKET,
  customerPendingItem,
});

export const storeAllCustomerPoints = (data) => ({
  type: STORE_CUSTOMERS_POINTS,
  data,
});

export const saveCustomer = (data, onSuccess, onError) => ({
  type: SAVE_CUSTOMER,
  data,
  onSuccess,
  onError,
});

export const storeUpdatedCustomer = (customer) => ({
  type: STORE_UPDATED_CUSTOMER,
  customer,
});

export const storeUpdatedCustomerImageWithPreview = (previewedFile) => ({
  type: STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW,
  previewedFile,
});

export const storeUpdatedCustomerWithPreview = (updatedCustomerItem) => ({
  type: STORE_UPDATED_CUSTOMER_WITH_PREVIEW,
  updatedCustomerItem,
});

export const previewCustomerFile = (previewRequest) => ({
  type: PREVIEW_CUSTOMER_FILE,
  previewRequest,
});

export const deleteCustomer = (data) => ({
  type: DELETE_CUSTOMER_ACCOUNT,
  data,
});

export const listRaffleCustomers = (data) => ({
  type: LIST_RAFFLE_CUSTOMERS,
  data,
});

export const storeAllRaffleCustomers = (data) => ({
  type: STORE_ALL_RAFFLE_CUSTOMERS,
  data,
});

export const clearAllCustomers = () => ({
  type: CLEAR_ALL_CUSTOMERS,
});

export const validateCustomerName = (data, callback) => ({
  type: VALIDATE_CUSTOMER_NAME,
  data,
  callback,
});
